import { Button, ComputerIcon } from "djinn-components";
import { Link } from "react-router-dom";

const AuthLayout: React.FC<any> = ({ children }) => {
  return (
    <>
      <title>Appsicle Login / Register</title>
      <meta name="description" content="Login or create an Appsicle account." />
      <link rel="icon" href="/icon.png" />

      <div className="hidden md:block w-screen h-screen bg-gradient-to-r from-black bg-gray-900 text-white">
        {children}
      </div>
      <div className="md:hidden bg-gray-900 h-screen w-screen flex items-center justify-center text-white flex-col">
        <ComputerIcon size={60} />
        <h1 className="text-3xl text-center max-w-xs my-10">
          Please log-in on your desktop device to access the admin area.
        </h1>
        <div className="w-[200px]">
          <Link to="/">
            <Button text="Home" isLink />
          </Link>
        </div>
      </div>
    </>
  );
};

export default AuthLayout;
